import React, { useEffect, useState } from 'react';
import { client } from '../../lib/axiosClient';
import { ClientsTabel, OrdersTabel } from '../../componants/Tables';
import { AddProject, ChangeStatusOrder, DeleteClient, SendMailToClient, UpdateClient, UpdateClientStatus, UpdateInfoClientOrder, UpdatePurchaseInformation } from '../../componants/Modal';
import { HeadPage } from '../../componants';
import { ActionIcon, Button, Container, Dialog, Drawer, Group, SegmentedControl, Stack, Text, TextInput } from '@mantine/core';
import { IconLock, IconSearch } from '@tabler/icons-react';
import classes from './../../styles/Product.module.css';
import { searchSortedData, sortedData } from '../../lib/sort';
import Cookies from 'universal-cookie';
import { useClients, useSearchOrders } from '../../api';
import { useDisclosure } from '@mantine/hooks';
import { DatePickerInput } from '@mantine/dates';
import XLSX from "sheetjs-style";
//@ts-ignore
import * as FileServer from "file-saver";
import dayjs from 'dayjs';
import { ShowClientDrawer } from '../../componants/Drawer';
import { useTranslation } from 'react-i18next';
import { AddClient } from '../../componants/Modal/AddClient';

const cookies = new Cookies(null, { path: '/' });

export function Clients () {
    const { t } = useTranslation();
    const [openAddModal, setOpenAddModal] = useState(false);
    const [openAddProjectModal, setOpenAddProjectModal] = useState(false);
    const [openSendMailModal, setOpenSendMailModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [openEditModal, setOpenEditModal] = useState(false);
    const [openEditPurchaseInformation, setOpenEditPurchaseInformation] = useState(false);
    const [openEditInfoModal, setOpenEditInfoModal] = useState(false);
    const [openEditStatusModal, setOpenEditStatusModal] = useState(false);
    const [openShowModal, setOpenShowModal] = useState(false);

    const [selectedData, setSelectedData] = useState<any>(null);

    const [search, setSearch] = useState('');

    const [orders, setOrders] = useState<any[]>([]);
    const [ordersSorted, setOrdersSorted] = useState<any[]>([]);
    const [version, setVersion] = useState("basic");

    const {loading, error, data: dataOrders, refetch} = useClients({
        status: "payment", version,
        referralCode: cookies.get('role') === "marketer" ? cookies.get('ref') || "" : "",
        confirmedID: cookies.get('role') === "confirmed" ? cookies.get('id') || "" : ""
    })
    const [role, setRole] = useState("");

    useEffect(() => {
        if (cookies.get('role')) {
            setRole(cookies.get('role'))
        }
    }, [cookies.get('role')])

    useEffect(() => {
        if (dataOrders) {
            setOrders(dataOrders)
            const newData = sortedData(dataOrders)
            setOrdersSorted(newData)
        }
    }, [dataOrders])

    useEffect(() => {
        if (search !== "") {
            const newData = searchSortedData(orders, ["name", "phone", "email"], search)
            setOrdersSorted(newData)
        } else {
            const newData = sortedData(orders)
            setOrdersSorted(newData)
        }
    }, [search])

    if (!["admin", "responsible", "marketer"].includes(role)) {
        return (
            <Container>
                <Stack align='center' justify='center' h={"calc(100vh - 130px)"}>
                    <IconLock size={45} strokeWidth={1.5} />
                    <Text>ليس لديك صلحيات للوصول لهذه الصفحة</Text>
                </Stack>
            </Container>
        )
    }

    return (
        <>
            <HeadPage
                page={"العملاء"}
                links={[
                    { title: "لوحة التحكم", href: '/dashboard' },
                    { title: "قائمة العملاء", href: '' }
                ]}
                labelExport={t('ordersPage.labelExport')}
                hiddenExport={true}
                labelCreate='اضافة عميل'
                onCreate={() => setOpenAddModal(true)}
                onExport={() => console.log()}
            />

            <Group justify='space-between' align='flex-end' mb={20}>
                <SegmentedControl
                    withItemsBorders={false} 
                    value={version}
                    onChange={setVersion}
                    data={[
                        {label: "الخطة البسيطة", value: "basic"},
                        {label: "الخطة الاحترافية", value: "pro"},
                        {label: "الخطة المخصصة", value: "custom"}
                    ]}
                    styles={{
                        root: {
                            border: "1px solid #E0E2E7",
                            background: "#fff",
                            height: 40,
                            alignItems: "center"
                        },
                        indicator: {
                            background: "#F2F7FB",
                            height: 30, minHeight: 30, maxHeight: 30,
                            boxShadow: "none"
                        }
                    }}
                    classNames={{
                        control: classes.control
                    }}
                />
                
                <TextInput
                    leftSectionPointerEvents="none"
                    leftSection={<IconSearch size={18} />}
                    placeholder={t('ordersPage.placeholder')}
                    styles={{
                        input: {height: 40}
                    }}
                    value={search}
                    onChange={(event) => setSearch(event.currentTarget.value)}
                />
            </Group>

            <ClientsTabel
                data={ordersSorted}
                setOpenDeleteModal={setOpenDeleteModal}
                setOpenEditModal={setOpenEditModal}
                setOpenEditInfoModal={setOpenEditInfoModal}
                setOpenShowModal={setOpenShowModal}
                setSelectedData={setSelectedData}
                setOpenAddProjectModal={setOpenAddProjectModal}
                setOpenEditPurchaseInformation={setOpenEditPurchaseInformation}
                setOpenEditStatusModal={setOpenEditStatusModal}
                setOpenSendMailModal={setOpenSendMailModal}
                loading={loading}
            />

            <AddClient title={"اضافة عميل"} refetchData={refetch} opened={openAddModal} onClose={() => setOpenAddModal(false)} />

            <UpdateClient title={"تعديل العميل"}  data={selectedData} refetchData={refetch} opened={openEditModal} onClose={() => setOpenEditModal(false)} />
            <DeleteClient data={selectedData} refetchData={refetch} opened={openDeleteModal} onClose={() => setOpenDeleteModal(false)} />
            <UpdateInfoClientOrder title={"تعديل تفاصيل طلب العميل"}  data={selectedData} refetchData={refetch} opened={openEditInfoModal} onClose={() => setOpenEditInfoModal(false)} />

            <AddProject title={"إضافة مشروع الى عميل"} refetchData={refetch} data={selectedData} opened={openAddProjectModal} onClose={() => setOpenAddProjectModal(false)} />
            <UpdatePurchaseInformation refetchData={refetch} data={selectedData} opened={openEditPurchaseInformation} onClose={() => setOpenEditPurchaseInformation(false)} />
            <UpdateClientStatus title={"تغيير حالة العميل مباشرة"}  data={selectedData} refetchData={refetch} opened={openEditStatusModal} onClose={() => setOpenEditStatusModal(false)} />
            <ShowClientDrawer title={"تفاصيل العميل"} data={selectedData} opened={openShowModal} onClose={() => setOpenShowModal(false)} />
            <SendMailToClient title={"ارسال بريد الكتروني الى العميل"} data={selectedData} opened={openSendMailModal} onClose={() => setOpenSendMailModal(false)} />
        </>
    );
}